import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7455d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "flow-model-title" }, "删除", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flow-model__subtitle mt14" }, "删除原因", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.type === 'list')
      ? (_openBlock(), _createBlock(_component_a_popconfirm, {
          key: 0,
          title: '删除后将无法恢复，请谨慎操作！',
          placement: "bottomRight",
          onConfirm: _ctx.handleOk,
          class: "append-to-table"
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteRow()))
            }, "删除")
          ]),
          _: 1
        }, 8, ["onConfirm"]))
      : (_openBlock(), _createBlock(_component_a_button, {
          key: 1,
          danger: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleDelete()))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.loading,
      centered: true,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      onOk: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleOk()))
    }, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_a_textarea, {
          "show-count": "",
          value: _ctx.approvalContent,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.approvalContent) = $event)),
          placeholder: '请输入删除原因，最多200字',
          "auto-size": { minRows: 3 },
          maxlength: 200,
          allowClear: ""
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible"])
  ], 64))
}